import api from '@/core/apiclient'
import {actionTypes} from '@/core/constants'

export default {

    async [actionTypes.SERVICO_ATENDIMENTO.BUSCAR_TODOS_SERVICOS]({state}, atendimentoId) {
        const {filtros, paginacao} = state.resultadoBuscaTodosServicosAtendimento
        filtros.atendimentoId.value = atendimentoId
        const {data} = await api.servicoAtendimento.buscarTodos(filtros, paginacao)
        return data
    },

    async [actionTypes.SERVICO_ATENDIMENTO.CADASTRAR_SERVICO](context, dados) {
        await api.servicoAtendimento.cadastrar(dados)
    },

    async [actionTypes.SERVICO_ATENDIMENTO.EDITAR_SERVICO](context, dados) {
        await api.servicoAtendimento.editar(dados)
    },

    async [actionTypes.SERVICO_ATENDIMENTO.EXCLUIR_SERVICO](context, dados) {
        await api.servicoAtendimento.excluir(dados)
    },
}